import { iterateNested } from "./json"
import { toObject } from "./dot"

/**
 * Casts a json objects primitive values from strings into their intended objects
 * 
 * @param {Object} json 
 * @returns {Object}
 */
export const castFromStrings = (json) => {
    let object = {}

    iterateNested(
        json,
        (key, value) => {
            object[key] = maybeCastValueFromString(value)
        },
        false,
        true
    )

    return toObject(object)
}

/**
 * Casts a given value into a fixed format
 * 
 * @param {*} value 
 * @returns {*}
 */
export const maybeCastValueFromString = (value) => {
    if(Array.isArray(value)){
        return value.map(maybeCastValueFromString)
    }

    if(String(value).toLocaleLowerCase() === 'true'){
        return true
    }

    if(String(value).toLocaleLowerCase() === 'false'){
        return false
    }

    if(
        String(value).toLocaleLowerCase() === 'undefined'
        || String(value).toLocaleLowerCase() === 'null'
    ){
        return null
    }

    if(/^-*[0-9]+(\.[0-9]+)?$/.test(value)){
        return parseFloat(value)
    }

    return value
}

/**
 * Casts js objects to strings
 * 
 * @param {Object} json 
 * @returns {Object}
 */
export const castToStrings = (json) => {
    let object = {}

    iterateNested(
        json,
        (key, value) => {
            object[key] = maybeCastValueToString(value)
        },
        false,
        true
    )

    return toObject(object)
}

/**
 * Converts a value to an API equivalent
 * 
 * @param {*} value 
 * @returns {*}
 */
export const maybeCastValueToString = (value) => {
    if(value === true){
        return 1
    }

    if(value === false){
        return 0
    }

    if(value === null || value === undefined){
        return ''
    }

    return value
}

/**
 * Converts an empty array or object to an empty string
 * 
 * @param {*} value 
 * @returns {*}
 */
export const maybeCastEmptyObjectToEmptyString = (value) => {
    if(value instanceof Object
        && !(value instanceof Date)
        && !(value instanceof File)
        && Object.keys(value).length === 0
    ){
        return ''
    }

    return value
}